<ng-container *transloco="let t">
  <IMultiSelectMenu [(value)]="selectedTypes">
    <ISelectTrigger size="sm">
      <ISelectValue [placeholder]="t('bulk-upload-preview.filter_preview')">
        <div *iSelectValue="let value">
          <div class="flex items-center gap-2">
            @for (type of selectedTypes(); track type) {
              <div class="flex items-center gap-2">
                <app-bulk-upload-type-icon [type]="type" />
                {{ t(LABELS_BY_TYPE[type]) }}
              </div>
            }
          </div>
        </div>
      </ISelectValue>
    </ISelectTrigger>
    <ISelectContent>
      @for (type of TYPES; track type) {
        <ISelectOption [value]="type">
          <div class="flex items-center gap-2">
            <app-bulk-upload-type-icon [type]="type" />
            {{ t(LABELS_BY_TYPE[type]) }}
          </div>
        </ISelectOption>
      }
    </ISelectContent>
  </IMultiSelectMenu>
</ng-container>
